import { atom } from 'jotai';

export interface InitialTriviaData {
  timeOut: boolean;
  start: boolean;
  stop: boolean;
  goToResult: boolean;
}

export const initialTriviaState = {
  timeOut: false,
  start: false,
  stop: false,
  goToResult: false,
};

export const triviaAtom = atom<InitialTriviaData>(initialTriviaState);
